import { getSecureItem } from './secureStorage';

// Cache for user data and permissions to avoid repeated localStorage access
let cachedUserData = null;
let cachedPermissions = null;
let isInitialized = false;

/**
 * Initialize the permission helper by loading data from secure storage
 * Call this once when the app starts or after login
 */
export function initializePermissionHelper() {
    try {
        cachedUserData = getSecureItem('userData');
        cachedPermissions = getSecureItem('permissions');
        isInitialized = true;
    } catch (error) {
        console.error('Error initializing permission helper:', error);
        cachedUserData = null;
        cachedPermissions = null;
        isInitialized = false;
    }
}

/**
 * Clear cached data (call this on logout)
 */
export function clearPermissionCache() {
    cachedUserData = null;
    cachedPermissions = null;
    isInitialized = false;
}

/**
 * Update cached user data (call this when user data changes)
 */
export function updateUserData(userData) {
    cachedUserData = userData;
}

/**
 * Update cached permissions (call this when permissions change)
 */
export function updatePermissions(permissions) {
    cachedPermissions = permissions;
}

export function checkPermission(resourceKey) {
    try {
        // Initialize if not done already
        if (!isInitialized) {
            initializePermissionHelper();
        }

        if (!cachedUserData) {
            return false;
        }

        // If user is superadmin, grant all permissions
        if (cachedUserData.role === 'superadmin') {
            return true;
        }

        // For other roles, check specific permissions
        if (!cachedPermissions || !Array.isArray(cachedPermissions)) {
            return false;
        }

        // Check if the resource key exists in user's permissions
        return cachedPermissions.includes(resourceKey);
    } catch (error) {
        return false;
    }
}